import { CollectionEntity } from "@busy-human/gearbox";
import { Builders } from "../Builders/index.js";
import { z } from "zod";
export var Trips;
(function (Trips) {
    Trips.TripGroupSchema = z.union([
        z.literal("parent_male"),
        z.literal("parent_female"),
        z.literal("teen_male"),
        z.literal("teen_female"),
        z.literal("hidden_duo")
    ]);
    function Default() {
        return {
            name: '',
            season: '',
            destination: '',
            startDate: '',
            endDate: '',
            groups: {
                'parent_female': {
                    max: 0,
                    registered: 0,
                    spots: 0
                },
                'parent_male': {
                    max: 0,
                    registered: 0,
                    spots: 0
                },
                'teen_female': {
                    max: 0,
                    registered: 0,
                    spots: 0
                },
                'teen_male': {
                    max: 0,
                    registered: 0,
                    spots: 0
                },
                'hidden_duo': {
                    max: 0,
                    registered: 0,
                    spots: 0
                }
            },
            totalSpots: 0,
            itinerary: null,
            groupMeLink: null,
            departureFlightSchedule: '',
            returnFlightSchedule: ''
        };
    }
    Trips.Default = Default;
    const DAY_IN_MS = 8.64e+7;
    /**
     * This assumes each trip slot is exactly the same length in days
     * @param slot A trip slot
     * @returns trip length in days
     */
    function GetTripLength(slot) {
        const start = new Date(slot.startDate).getTime();
        const end = new Date(slot.endDate).getTime();
        return Math.floor((end - start) / DAY_IN_MS);
    }
    Trips.GetTripLength = GetTripLength;
    /**
     *
     * @param slot A trip slot
     * @param start Potential start date
     * @param end Potential end date
     * @return whether the trip fits within the start and end dates
     */
    function IsTripBetween(slot, start, end) {
        const selectedStart = start.getTime();
        const selectedEnd = end.getTime();
        const tripStart = new Date(slot.startDate).getTime();
        const tripEnd = new Date(slot.endDate).getTime();
        return (tripStart >= selectedStart && tripEnd <= selectedEnd);
    }
    Trips.IsTripBetween = IsTripBetween;
    /** Returns true if the trip has slots available */
    function IsSlotAvailable(slot) {
        for (const group in slot.groups) {
            const t = slot.groups[group];
            if (t && t.registered < t.max)
                return true;
        }
        return false;
    }
    Trips.IsSlotAvailable = IsSlotAvailable;
    function resolveTripGroupSlot(builder, isPaired) {
        if (isPaired && builder.builderType === Builders.BuilderType.Builder) {
            return "hidden_duo";
        }
        switch (builder.gender) {
            case "male":
                if (builder.builderType === Builders.BuilderType.Builder) {
                    return "teen_male";
                }
                else if (builder.builderType === Builders.BuilderType.ParentBuilder) {
                    return "parent_male";
                }
                break;
            case "female":
                if (builder.builderType === Builders.BuilderType.Builder) {
                    return "teen_female";
                }
                else if (builder.builderType === Builders.BuilderType.ParentBuilder) {
                    return "parent_female";
                }
                break;
        }
        throw new Error("Could not resolve trip group slot");
    }
    Trips.resolveTripGroupSlot = resolveTripGroupSlot;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getAllAsMap() {
            return new Map((await this.fetchAll()).dataItems().map(b => ([b.$id, b])));
        }
    }
    Trips.CollectionClass = CollectionClass;
    Trips.Collection = new CollectionClass({ path: '/TripSlots' });
})(Trips || (Trips = {}));
//# sourceMappingURL=index.js.map